import { render, staticRenderFns } from "./fav_list.vue?vue&type=template&id=71e0c267&scoped=true"
import script from "./fav_list.vue?vue&type=script&lang=js"
export * from "./fav_list.vue?vue&type=script&lang=js"
import style0 from "./fav_list.vue?vue&type=style&index=0&id=71e0c267&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e0c267",
  null
  
)

export default component.exports